module.exports = __webpack_public_path__ + "media/images/loading-b01ebdf188b9a2ee7646acccbfbc256d.svg";